import styled from '@emotion/styled';

export const StyledLink = styled.a`
  position: absolute;
  padding: 0 10px;
  height: 26px;
  z-index: 10;
  background: var(--podium-cds-color-bg-primary);
  font-size: 14px;
  left: 0;
  min-height: 26px;
  line-height: 26px;
  transform: translateX(-10000%);
  margin: 5px 0px 0px 10px;
  &:focus {
    transform: translateX(0%);
  }
`;
